import React from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useUpdateResource } from "../../../../hooks/useUpdateResource";
import InputField from "../../../form/InputField";
import SubmitButton from "../../../form/SubmitButton";
import LoadingButton from "../../../form/LoadingButton";

export interface ComissionFormFormData {
  commission:number
}

interface Props {
  defaultValues: ComissionFormFormData;
  id:number;
  onSubmitSuccess?: () => void;
}

const ComissionForm: React.FC<Props> = ({ defaultValues, id,onSubmitSuccess }) => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ComissionFormFormData>({
    defaultValues, // prefill the form with provided values
  });

  
      const {loading,updateResource} = useUpdateResource();
  
    const onSubmit: SubmitHandler<ComissionFormFormData> = async (data) => {
          await  updateResource(`store-commission`, {storeId:id,commissionPercent:+data.commission }, "admin",{
              method: "POST",
              successMessage: t("update_success"),
              invalidateQueries:["store-detalis-by-admin"],
            });
          if (onSubmitSuccess) onSubmitSuccess();
    };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="grid  gap-4"
    >
      <InputField
        placeholder=""
        label={t("commission")}
        register={register("commission", {
          required: t("required_field"),
        })}
        type="number"
        error={errors.commission}
      />


    {
            loading
            ?
            <LoadingButton/>
            :
            <SubmitButton label={t("update")} />
    }
    </form>
  );
};

export default ComissionForm;
